module.exports = __webpack_public_path__ + "img/user.c2898784.svg";